<div>
  <d2d-status-banner-strip />
  <div style="height: calc(6rem + var(--status-banner-height, 0px))">
    <d2d-header></d2d-header>
  </div>

  <main class="min-h-screen">
    <router-outlet></router-outlet>
  </main>

  <d2d-client-footer />

  @defer (on idle) {
    <p-speeddial
      [model]="items"
      direction="up"
      mask
      [style]="{
        position: 'fixed',
        right: '1rem',
        bottom: '1rem',
        zIndex: 1000,
        alignItems: 'end',
      }"
      maskClassName="z-[999] bg-black/50 backdrop-blur-sm fixed inset-0"
      buttonClassName="shadow-md"
    >
      <ng-template #item let-item let-toggleCallback="toggleCallback">
        <div
          tabindex="0"
          role="button"
          class="flex items-center gap-2 cursor-pointer group"
          (click)="item.command?.($event); toggleCallback()"
          (keydown.enter)="item.command?.($event); toggleCallback()"
        >
          <span
            class="text-white text-lg max-w-0 group-hover:max-w-[180px] transition-all overflow-hidden max-h-7"
          >
            {{ item.label }}
          </span>
          <p-button [icon]="item.icon" severity="secondary" rounded size="large" />
        </div>
      </ng-template>
    </p-speeddial>
  }
</div>
